import Subheadline from "../Elements/Subheadline";
import ProfileCard from "../Cards/CardProfile";
import BtnSecondaryM from "../Buttons/BtnSecondaryM";
import PropTypes from "prop-types";

const TabResources = ({ copy }) => (
  <>
    <Subheadline
      subheadline={copy.profile.cards.resources.subheadline}
      description={copy.profile.tab_3_description}
    />
    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
      <ProfileCard
        title={copy.profile.resources.blog.title}
        description={copy.profile.resources.blog.description}
      >
        <BtnSecondaryM
          onClickLink="https://www.niumi.dk/blog/"
          buttonCTA={copy.profile.resources.blog.button}
        />
      </ProfileCard>
      <ProfileCard
        title={copy.profile.resources.glossary.title}
        description={copy.profile.resources.glossary.description}
      >
        <BtnSecondaryM
          onClickLink="https://www.niumi.dk/glossary/"
          buttonCTA={copy.profile.resources.glossary.button}
        />
      </ProfileCard>
      <ProfileCard
        title={copy.profile.resources.help_center.title}
        description={copy.profile.resources.help_center.description}
      >
        <BtnSecondaryM
          onClickLink="https://www.niumi.dk/help-center/"
          buttonCTA={copy.profile.resources.help_center.button}
        />
      </ProfileCard>
      <ProfileCard
        title={copy.profile.resources.newsletter.title}
        description={copy.profile.resources.newsletter.description}
      >
        <BtnSecondaryM
          onClickLink="https://www.niumi.dk/newsletter/"
          buttonCTA={copy.profile.resources.newsletter.button}
        />
      </ProfileCard>
    </div>
  </>
);

TabResources.propTypes = {
  copy: PropTypes.object.isRequired,
};

export default TabResources;
